import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/views/index/router/index.js